var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportProblem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#FBF6D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14C14 12.8954 14.8954 12 16 12H24C25.1046 12 26 12.8954 26 14V25C26 25.5523 25.5523 26 25 26H15C15 26.5523 15.4477 27 16 27H25.5C25.7761 27 26 27.2239 26 27.5C26 27.7761 25.7761 28 25.5 28H16C14.8954 28 14 27.1046 14 26V14ZM20 15C19.7239 15 19.5 15.2239 19.5 15.5V19.5C19.5 19.7761 19.7239 20 20 20C20.2761 20 20.5 19.7761 20.5 19.5V15.5C20.5 15.2239 20.2761 15 20 15ZM20.75 22.25C20.75 21.8358 20.4142 21.5 20 21.5C19.5858 21.5 19.25 21.8358 19.25 22.25C19.25 22.6642 19.5858 23 20 23C20.4142 23 20.75 22.6642 20.75 22.25Z",
    fill: "#835C00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportProblem);
export default __webpack_public_path__ + "static/media/ReportProblem.a2b8f4f2efd9eda037d7d0b57eb5ad1e.svg";
export { ForwardRef as ReactComponent };